import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './ServicePages.css';
import { fadeInUp } from '../constants/animations';

function CustomDesign() {
  return (
    <main className="service-page">
      <div className="service-container">
        <motion.div className="service-hero" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.25 }}>
          <motion.h1 variants={fadeInUp} custom={0}>Custom Design</motion.h1>
          <motion.p variants={fadeInUp} custom={1}>Clean, fast, mobile‑friendly websites built to convert visitors into calls, bookings, and sales.</motion.p>
        </motion.div>

        <div className="service-section">
          <motion.div className="service-feature" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={0}>
            <h4>Conversion‑first layouts</h4>
            <p>Clear messaging, strategic CTAs, and clean structure that drives bookings.</p>
          </motion.div>
          <motion.div className="service-feature" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={1}>
            <h4>Local SEO foundations</h4>
            <p>Built to rank by default with optimized structure, speed, and metadata.</p>
          </motion.div>
          <motion.div className="service-feature" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={2}>
            <h4>Mobile‑perfect</h4>
            <p>Every page is designed for fast, elegant mobile performance.</p>
          </motion.div>
        </div>

        <motion.div className="service-block" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.25 }} variants={fadeInUp} custom={0}>
          <h3>What you get</h3>
          <ul className="service-list">
            <li>Custom website design (no bloated templates)</li>
            <li>Brand polish and logo refresh if needed</li>
            <li>Lead capture forms and contact routing</li>
            <li>Google‑friendly structure and page speed</li>
            <li>Managed updates, backups, and support</li>
          </ul>
        </motion.div>

        <div className="service-split">
          <motion.div className="service-split-card" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={0}>
            <h4>Who it’s for</h4>
            <p>Service providers, local shops, and established businesses ready for a modern web presence.</p>
          </motion.div>
          <motion.div className="service-split-card" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={1}>
            <h4>Typical timeline</h4>
            <p>Most brochure sites launch in days once we have your content.</p>
          </motion.div>
        </div>

        <motion.div className="service-faq" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
          <motion.h3 variants={fadeInUp} custom={0}>FAQs</motion.h3>
          <div className="service-faq-grid">
            <motion.div className="service-faq-item" variants={fadeInUp} custom={1}>
              <h5>Do I need to write the content?</h5>
              <p>No. We can clean up what you have or draft simple copy.</p>
            </motion.div>
            <motion.div className="service-faq-item" variants={fadeInUp} custom={2}>
              <h5>Can you migrate my current site?</h5>
              <p>Yes. We migrate from WordPress, Wix, Squarespace, Shopify, and more.</p>
            </motion.div>
          </div>
        </motion.div>

        <motion.div className="service-cta" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.35 }} variants={fadeInUp} custom={0}>
          <Link to="/plans">Get Started</Link>
        </motion.div>
      </div>
    </main>
  );
}

export default CustomDesign;
